import { render, staticRenderFns } from "./PosProductCard.template.vue?vue&type=template&id=5533d22f&scoped=true&"
var script = {}
import style0 from "./PosProductCard.template.vue?vue&type=style&index=0&id=5533d22f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5533d22f",
  null
  
)

export default component.exports